import React, { useState } from 'react';
import styles from './PopoverRegistrationAll.module.scss';
import { Button, Popover, Tooltip } from 'antd';
import { ReactComponent as TemplatePopover } from '../../../../../resource/TemplatePopover.svg';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';

const PopoverContent = ({ onClick, currentCompany }) => {
  const history = useHistory();

  const { ChangeHouseRegistrationType } = useSelector(
    (state) => state.authentication.userInfo
  );

  const chandePopover = () => {
    history.push(`/HousingStock/company/${currentCompany.id}/changingAll`);
    onClick();
  };

  const isDisabledRegistration = !ChangeHouseRegistrationType;

  return (
    <ul className={styles.listType}>
      <Tooltip
        title={
          isDisabledRegistration
            ? 'У вас нет права для изменения режима регистрации'
            : ''
        }
      >
        <Button
          key={1}
          disabled={isDisabledRegistration}
          style={{
            padding: 0,
            color: isDisabledRegistration ? 'gray' : 'black',
          }}
          onClick={chandePopover}
          type="link"
        >
          Изменить режим регистрации
        </Button>
      </Tooltip>
    </ul>
  );
};

const PopoverRegistrationAll = ({ currentCompany }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      style={{ cursor: 'pointer' }}
    >
      <Popover
        placement="right"
        content={
          <PopoverContent
            onClick={() => {
              setVisible(false);
            }}
            currentCompany={currentCompany}
          />
        }
        trigger="click"
        visible={visible}
        onVisibleChange={(v) => setVisible(v)}
      >
        <TemplatePopover />
      </Popover>
    </div>
  );
};

export default PopoverRegistrationAll;
